import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { SWITCH_DEFAULT_DISABLED, SWITCH_DEFAULT_MODE, SWITCH_DEFAULT_ON, SWITCH_DEFAULT_ROLE, SWITCH_DEFAULT_SIZE } from './Switch.constants';
import { SwitchLabel, SwitchRoot, SwitchWrapper } from './Switch.styled';
// Component.
// -----------------------------------------------------------------------------
const Switch = forwardRef(({ disabled = SWITCH_DEFAULT_DISABLED, label, mode = SWITCH_DEFAULT_MODE, name, checked: on = SWITCH_DEFAULT_ON, onChange, role = SWITCH_DEFAULT_ROLE, size = SWITCH_DEFAULT_SIZE, ...rest }, ref) => {
    return (_jsxs(SwitchWrapper, { children: [_jsx(SwitchRoot, { checked: on, ...(role && { className: role }), disabled: disabled, id: name, mode: mode, name: name, onChange: onChange, ref: ref, ...rest }), label && (_jsx(SwitchLabel, { htmlFor: name, scale: size, children: label }))] }));
});
// Component configuration.
// -----------------------------------------------------------------------------
Switch.displayName = 'Switch';
export default Switch;
//# sourceMappingURL=Switch.js.map